export default "__VITE_ASSET__70686013__"